import React from 'react'
import PropTypes from 'prop-types'

import ProposalSectionsWrapper from 'agency/digital_renderer/components/ProposalSectionsWrapper'
import ProposalSectionWrapper from 'agency/digital_renderer/components/ProposalSectionWrapper'
import LoadingBubbles from 'components/LoadingBubbles'

import ProposalSection from './ProposalSection'
import styles from './styles.scss'

const CustomSections = (props) => {
  const { campaignProposal, editing } = props

  return (
    <ProposalSectionsWrapper
      campaignProposal={campaignProposal}
      render={({ createSection, creatingSection, sections }) => (
        <div className={styles.root}>
          <div className={styles.sections}>
            {sections.map((section, index) => (
              <ProposalSectionWrapper
                campaignProposalSection={section}
                editingProposal={editing}
                key={section.id}
                render={renderProps => (
                  <ProposalSection light={index % 2 !== 0} campaignProposalSection={section} {...renderProps} />
                )}
              />
            ))}
          </div>

          {editing && (
            <a className={styles.addSection} onClick={createSection} tabIndex="0">
              {creatingSection ? <LoadingBubbles color="#ffffff" /> : 'Add Custom Section'}
            </a>
          )}
        </div>
      )}
    />
  )
}

CustomSections.propTypes = {
  campaignProposal: PropTypes.object.isRequired,
  editing: PropTypes.bool,
}

export default CustomSections
